import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

function Subheader(props) {
  const { classes } = props;
  return (
    <Typography className={classes.typography} styles={props.styles}>
      {props.children}
    </Typography>
  );
}

Subheader.propTypes = {
  children: PropTypes.string,
  styles: PropTypes.object,
  classes: PropTypes.object.isRequired,
};

Subheader.defaultProps = {
  children: '',
  styles: null,
};

const styles = () => ({
  typography: {
    boxSizing: 'border-box',
    fontSize: 14,
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.54)',
    lineHeight: 3,
    width: '100%',
  },
});

export default withStyles(styles)(Subheader);



// WEBPACK FOOTER //
// ./src/app/components/subheader/subheader.js